import React, { useEffect, useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import { Typography } from '@mui/material';
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import TituloPagina2 from "conten/components/TituloPagina2";
import { Paper, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { addMessage } from "conten/mensajes/MessagesActions";
import { connect } from "react-redux";
import DispositivosEnUsoApiHelper from "./DispositivoEnUsoApiHelper";
import { ID_CUENTA } from "config/general/Configuracion";
import { Table } from "@material-ui/core";
import { MobileScreenShare } from "@material-ui/icons";


const DispositivoEnUso = ({ classes, addMessage }) => {
  const [dispositivos, setDispositivos] = useState([]);
  const cuentaId = sessionStorage.getItem(ID_CUENTA);

  const listarDispositivos = async () => {
    try {
      const response = await DispositivosEnUsoApiHelper.listarDispositivosEnUso(cuentaId);
      setDispositivos(response || []);
    } catch (error) {
      console.error("Error al listar dispositivos en uso:", error);
      addMessage({
        variant: "danger",
        message: `Error al listar dispositivos en uso: ${error.message}`,
      });
    }
  };

  useEffect(() => {
    listarDispositivos();
  }, []);

   return (
    <GridItem xs={12}>
      <Card>
        <CardHeader icon>
          <CardIcon color="info">
            <MobileScreenShare />
          </CardIcon>
          <TituloPagina2 texto="Dispositivos en uso" classes={classes} />
        </CardHeader>
        <CardBody>
          {dispositivos.length === 0 ? (
            <Typography>No hay dispositivos en uso actualmente.</Typography>
          ) : (
            <Paper elevation={1}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Dispositivo</strong></TableCell>
                    <TableCell><strong>Modelo</strong></TableCell>
                    <TableCell><strong>Usuario</strong></TableCell>
                    <TableCell><strong>Linea celular</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dispositivos.map((d) => (
                    <TableRow key={d.android_id}>
                      <TableCell>{d.nombre_dispositivo}</TableCell>
                      <TableCell>{d.modelo}</TableCell>
                      <TableCell>{d.nombre_usuario}</TableCell>
                      {d.linea_celular && (
                        <TableCell>{d.linea_celular}</TableCell>
                      ) || <TableCell>No disponible</TableCell>}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          )}
        </CardBody>
      </Card>
    </GridItem>
  );
};


const mapDispatchToProps = (dispatch) => {
    return {
        addMessage: (content) => dispatch(addMessage(content)),
    };
};

export default withStyles(extendedTablesStyle)(
    connect(
        null,
        mapDispatchToProps
    )(DispositivoEnUso)
);